import {
  createReactRouterV7DataOptions,
  getWebInstrumentations,
  initializeFaro,
  ReactIntegration,
  withFaroRouterInstrumentation,
} from '@grafana/faro-react';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { matchRoutes } from 'react-router-dom';

export const initFaroWithRouter = () => {
  const isProductionApp = process.env.IS_PRODUCTION_APP === 'true';
  if (!isProductionApp) {
    console.log('Faro instrumentation disabled in development and staging mode');
    return;
  }

  try {
    initializeFaro({
      url: 'https://faro-collector-prod-us-east-2.grafana.net/collect/d95243ab2be9351b0ae375f82c85fbf3',
      app: {
        name: 'calyx-platform-ui',
        version: process.env.GITHUB_VERSION_NUMBER || '1.0.0',
        environment: process.env.NODE_ENV,
      },
      instrumentations: [
        ...getWebInstrumentations(),
        new ReactIntegration({
          router: createReactRouterV7DataOptions({
            matchRoutes,
          }),
        }),
        new TracingInstrumentation(),
      ],
    });
    console.log('Faro instrumentation initialized successfully with React Router integration');
  } catch (error) {
    console.error('Failed to initialize Faro instrumentation:', error);
  }
};

export { withFaroRouterInstrumentation };
